import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/cartInfo.css'

import Popup from "../components/Popup";
import { totalPrice, priceFormat } from "../inc/Fetch";
import { Img } from "../components/Elements";

import { IoClose } from "react-icons/io5";

export default function CartInfo() {

	const { t } = useTranslation();
	let navigate = useNavigate();
	const location = useLocation();
	let ref = useRef(0);

	// const {siteData, successData, user} = useContext(AppContext); 
	// const [siteInfo, setsiteInfo] = siteData;

	const [selected, setselected] = useState(0);
	const [values, setvalues] = useState(location?.state?.data || {});

	function scrollInto(k) {
		setselected(k);
	}

	let priceAdded = 0;
	return (
		<>
			<Popup 
				className="cartInfoPopup"
			>
				<a className='close' onClick={() => navigate(-1)}><IoClose /></a>

				<div ref={ref} className='cartInfoMainImgsBox'>
					{values?.img?.map((v, k) => {
						return (
							<Img key={k} className={`cartInfoMainImg ${selected == k && "checked"}`} src={`img/500/${v}`}/>
						);
					})}
					
				</div>
				{values?.img?.length > 1 ?
				<div className='cartInfoMainThumbBox'>
					{values?.img?.map((v, k) => {
						return (
							<a  onClick={() => setselected(k)}><Img key={k} className={`cartInfoMainThumb ${selected == k && "checked"}`} src={`img/100/${v}`}/></a>
						);
					})}
					
				</div>: false}

				<div className='cartInfoMainTextAndPrice'>
					<h1>{values?.title}</h1>
					<span>{priceFormat(values?.price)} {global?.currency}</span>
				</div>

				<div className='cartInfoMainfull'>{values?.full}</div>

				{values?.selectedOptions?.length ? <div className='cartInfoBox' style={{background:"#f9f9f9"}}>
					<b>{t("cart_summery")}</b>
					<table>
						
						{values?.selectedOptions?.map((v, k) => {
							if (v?.type == "count") {

								priceAdded += v?.price * v?.val;
								return (
									<tr>
										<td>{v?.name}</td>
										<td><span>x</span>{v?.val}</td>
										<td>{priceFormat(v?.price * v?.val)} <span>{global?.currency}</span></td>
									</tr>
								);
							} else {
								priceAdded += v?.price;
								return (
									<tr>
										<td>{v?.name}</td>
										<td><strong style={{backgroundColor: v?.type == "colors" ? v?.val : ""}} className={`tag ${v?.type == "colors" && "colorBox"}`}>{v?.type != "colors" && v?.val}</strong></td>
										<td>{priceFormat(v?.price)} <span>{global?.currency}</span></td>
									</tr>
								);
							}
							
						})}
					</table>

				</div>: false}

				<div className='cartInfoBox'>
					<b>{t("cart_summery")}</b>
					<table>
						
						

						<tr>
							<td>{t("price")}</td>
							<td>{priceFormat( Number(values?.price) + Number(priceAdded))} <span>{global?.currency}</span></td>
						</tr>

						<tr>
							<td>{t("qnt")}</td>
							<td>{values?.num}</td>
						</tr>
						<tr className='total'> 
							<td>{t("cart_total")}</td>
							<td>{priceFormat(totalPrice(values))} <span>{global?.currency}</span></td>
						</tr>
					</table>

				</div>
			</Popup>
			
		</>
	)
}
